import api from "../api";

export async function downloadCsv(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = window.URL.createObjectURL(new Blob([data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
}

export async function downloadPdf(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = window.URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
}
